module.exports = __webpack_public_path__ + "87b7262787b05e9dc9e84fdecbfa86df.png";